'use client'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { Footer } from '@mercadoni/sinister/dist/cjs/footer'
import { useGroupedPages } from '@mercadoni/sinister/dist/cjs/header'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import VisibleElement from '../VisibleElement'

const FooterComponent = ({ userAgent }: { userAgent?: string }) => {
  const copies = getLocale() || defaultLocale
  const { groupedPages } = useGroupedPages({ position: 'footer' })
  const { help, helpV3 } = UseClientModelContext()
  const [isMobile] = useIsMobile(userAgent)

  return (
    <VisibleElement
      offset="100px"
      height={100}
      timer={3000}
      dataName="footer"
      defaultDisplay={false}
    >
      <Footer
        copies={copies}
        groupedPages={groupedPages}
        help={help}
        helpV3={helpV3}
        isMobile={isMobile}
      />
    </VisibleElement>
  )
}

export default FooterComponent
